export const NEWS = 'news';
export const EVENTS = 'events';
export const NUTRITION = 'nutrition';
export const TRAINING = 'training';

export const blogCategories = [NEWS, TRAINING];
